module.exports = __webpack_public_path__ + "static/media/img_logo_pro.9f7f2bbc.png";